const TagsEnum = {
  SCRIPT: 'script',
  IMAGE: 'image',
  EXTERNAL_STYLES: 'externalStyles',
  SVG_TAG: 'svgTag',
  SVG_PATH: 'svgPath',
  UNICODE: 'unicode',
  EMBED: 'embed',
  SRCDOC: 'srcDoc',
}

// Badge types
const BADGE_TYPES = {
  LEADERBOARD: 'leaderboard',
  SUBMISSION: 'submission',
  STREAK: 'streak',
  TARGET_PLAYED: 'targetPlayed',
}

// Badge IDs
const BADGE_IDS = {
  // Leaderboard badges
  BATTLE_TOP_1: 'battleTop1',
  BATTLE_TOP_2: 'battleTop2',
  BATTLE_TOP_3: 'battleTop3',

  TARGET_TOP_10: 'targetTop10',
  TARGET_TOP_5: 'targetTop5',
  TARGET_TOP_3: 'targetTop3',
  TARGET_TOP_2: 'targetTop2',
  TARGET_TOP_1: 'targetTop1',

  // Submission badges
  FIRST_SUBMISSION: 'firstSubmission',
  HUNDRED_SUBMISSIONS: 'hundredSubmissions',
  THOUSAND_SUBMISSIONS: 'thousandSubmissions',
  TEN_K_SUBMISSIONS: 'tenKSubmissions',
  FIFTY_K_SUBMISSIONS: 'fiftyKSubmissions',
  HUNDRED_K_SUBMISSIONS: 'hundredKSubmissions',

  // Target count badges
  TARGET_PLAYED_10: 'targetPlayed10',
  TARGET_PLAYED_50: 'targetPlayed50',
  TARGET_PLAYED_100: 'targetPlayed100',
  TARGET_PLAYED_500: 'targetPlayed500',
  TARGET_PLAYED_1000: 'targetPlayed1000',
  TARGET_PLAYED_5000: 'targetPlayed5000',

  STREAK_7: 'streak7',
  STREAK_30: 'streak30',
  STREAK_100: 'streak100',
  STREAK_365: 'streak365',
  STREAK_500: 'streak500',
  STREAK_2Y: 'streak2y',
}

module.exports = {
  TagsEnum,
  BADGE_TYPES,
  BADGE_IDS,
}
